<template>
  <grid-x col="1fr 7fr" rows="1fr" gap="2em">
    <div class="col-1">
      <h3>Competitions</h3>
      <div class="input-box down-caret">
        <select
          v-model="selectedCompetitionKey"
          class="podcast-list-select"
          @focus="changeColor()"
          ref="competitionSelector"
        >
          <option disabled value>Select a competition</option>
          <option v-for="(item,key) in competitions" :key="key" :value="item['.key']">{{item.name}}</option>
        </select>
      </div>
      <div>
        <div class="widget-buttons">
          <button @click="showNewCompetition = !showNewCompetition">New Competition</button>
        </div>
        <div v-if="showNewCompetition">
          <div class="input-box">
            <input v-model="newCompetition.name" type="text" placeholder="Competition Name">
          </div>
          <button @click="createCompetition">Create Competition</button>
        </div>
      </div>
    </div>
    <div class="col-2" style="padding-right: 100px;">
      <div v-if="selectedCompetitionKey" class="section-title">
        <h3>{{selectedCompetition.name}}</h3>
        <div class="tab-container">
          <button :class="{ 'active-tab': currentTab === 'post', tab: true}" @click="currentTab = 'post';">Manage Post</button>
          <button :class="{ 'active-tab': currentTab === 'results', tab: true}"  @click="currentTab = 'results';getResults();"
        >View Results</button>
        </div>
      </div>
      <grid-x col="2fr 0.5fr" rows="1fr" gap="2em">
        <div class="col-2-1">
          <div v-if="selectedCompetitionKey">
            <div v-if="currentTab == 'post'">
              <div class="input-label">Title</div>
              <div class="input-box">
                <input v-model="selectedCompetition.title" type="text" placeholder="Title">
              </div>
              <froala-editor v-model="selectedCompetition.writtenContent"></froala-editor>

              <div id="fb-editor"></div>

              <!-- <button @click="saveCompData(selectedCompetition)">SAVE</button> -->
            </div>
            <div v-if="currentTab == 'results'">
              <div v-if="results && results.length > 0">
                <button @click="exportCsv()">Export To CSV</button>
                <table>
                  <th v-for="(field, key, index) in results[0]" v-bind:key="index">{{key}}</th>
                  <tr v-for="(row, index) in results" v-bind:key="index">
                    <td v-for="(data, index) in row" v-bind:key="index">{{data}}</td>
                  </tr>
                </table>
              </div>
              <div v-else>No results</div>
            </div>
            <div class="widget-buttons">
              <button
                class="pub-buttons"
                v-if="selectedCompetition.status == 'draft' || selectedCompetition.status == 'preview'"
                @click="publishCompetition();"
              >Publish</button>
              <button
                class="pub-buttons"
                v-if="selectedCompetition.status == 'draft'"
                @click="previewCompetition();"
              >Preview</button>
              <button
                class="pub-buttons"
                v-if="selectedCompetition.status == 'publish' || selectedCompetition.status == 'preview'"
                @click="unpublishCompetition();"
              >Unpublish</button>
              <button class="pub-buttons" @click="saveCompData(selectedCompetition)">SAVE</button>
            </div>
          </div>
        </div>
        <div class="col-2-2">
          <div v-if="currentTab == 'post' && selectedCompetitionKey">
            <h1>Meta</h1>
            <div class="input-label">Slug</div>
            <div :class="'input-box slug-input ' + slugValid">
              <input
                v-model="selectedCompetition.slug"
                @input="checkSlug"
                type="text"
                placeholder="Slug"
              >
              <span style="padding-top: 5px;padding-right: 5px;">{{slugValid}}</span>
            </div>
            <div v-if="selectedCompetition.meta">
              <div class="input-label">SEO Title</div>
              <div class="input-box">
                <input v-model="selectedCompetition.meta.title" type="text" placeholder="SEO Title">
              </div>
              <div class="input-label">SEO Description</div>
              <div class="input-box">
                <input
                  v-model="selectedCompetition.meta.description"
                  type="text"
                  placeholder="SEO Description"
                >
              </div>
            </div>
            <div class="input-label">Tags</div>
            <!-- Needs a hard coded array of tags in :options -->
            <div class="tag-input-container">
              <tag-input :options="tags" placeholder="Enter tags" :value="selectedCompetition.tags" :multiple="true" @value="updateTags"></tag-input>
            </div>
            <div class="input-label">Select Category</div>
            <div class="input-box down-caret">
              <select v-model="selectedCompetition.parentCategory" @change="selectCategory()">
                <option
                  v-for="(item,key) in categories"
                  :key="key"
                  :value="item.name"
                >{{ item.name }}</option>
              </select>
            </div>
            <div class="input-box down-caret" v-if="categoryChanged">
              <select v-model="selectedCompetition.subCategory">
                <option
                  v-for="(subitem,subkey) in subCategories"
                  :key="subkey"
                  :value="subitem.name"
                >{{ subitem.name }}</option>
              </select>
            </div>
            <div class="images">
              <div class="featured-images">
                <h3>Featured Image</h3>
                <img
                  v-if="selectedCompetition.image"
                  :src="selectedCompetition.image"
                >
                <ic-firebase-upload
                  v-model="selectedCompetition.image"
                  path="images"
                  max-files="1"
                  :getFileName="getFileName"
                  :storage="storage"
                  @uploaded="onUploadedCompImage($event,'image')"
                  @upload="onUpload"
                  @delete="onDelete"
                ></ic-firebase-upload>
              </div>
              <div class="social-images">
                <h3>Social Image</h3>
                <img
                  v-if="selectedCompetition.socialImage"
                  :src="selectedCompetition.socialImage"
                >
                <ic-firebase-upload
                  v-model="selectedCompetition.socialImage"
                  path="images"
                  max-files="1"
                  :getFileName="getFileName"
                  :storage="storage"
                  @uploaded="onUploadedCompImage($event,'socialImage')"
                  @upload="onUpload"
                  @delete="onDelete"
                ></ic-firebase-upload>
              </div>
            </div>
          </div>
        </div>
      </grid-x>
    </div>
  </grid-x>
</template>

<script>
/*
  TODO:
    Create post button pieces together html and creates a post object
      Implement Form render outputting HTML for the above
      Prevent slug collisions
    Save to competitions database
      Save format for form builder / froala content
    Data validation
    View Results
      Preview of data in table (first 20 rows?)
        Ability to delete a row (test data)
      Export all data to CSV
*/

import Vue from "vue";
import firebase from "firebase";
import VueFirestore from "vue-firestore";
require("firebase/firestore");
import pageList from "../widgets/pageList";
import gridX from "../widgets/gridX";
Vue.use(VueFirestore);
var firestore;
import FroalaEditor from "../common/articleWidgets/Froala";
import IcFirebaseUploader from "ic-firebase-uploader";
import "ic-firebase-uploader/dist/ic-firebase-uploader.min.css";
import TagInput from "../common/atoms/TagInput";
import config from "../../config.json";

export default {
  components: {
    pageList,
    FroalaEditor,
    gridX,
    "ic-firebase-upload": IcFirebaseUploader,
    TagInput,
  },
  firestore() {
    return {
      // Collection
      competitions: firestore.collection("competitions"),
      categories: firestore.collection("categories")
    };
  },
  mounted() {
    this.tags = [];
    firebase.firestore()
      .collection("tags")
      .get()
      .then((querySnap) => {
        querySnap.forEach((tagSnap) => {
          this.tags.push(tagSnap.id);
        });
        this.showTags = true;
      });
  },
  data: function() {
    firestore = firebase.firestore();
    return {
      storage: firebase.storage(),
      results: [],
      newCompetition: {
        meta: {
          title: "",
          description: ""
        }
      },
      tags: [],
      selectedCompetitionKey: "",
      selectedCompetition: {
        status: "",
        meta: {
          title: "",
          description: ""
        }
      },
      formBuilder: null,
      //selectedCompetition: false,
      currentTab: "post",
      showNewCompetition: false,
      categoryChanged: false,
      debounceSlug: false,
      checkSlugRandom: null,
      slugValid: "",
      changeCat: false,
      subCategories: null
    };
  },
  watch: {
    selectedCompetitionKey: function(val) {
      // Binding Docs
      this.$binding(
        "selectedCompetition",
        firestore.collection("competitions").doc(val)
      )
        .then(ford => {
          this.selected();
        })
        .catch(err => {
          console.error(err);
        });
    }
  },
  methods: {
    addTag: function(event) {
      this.selectedCompetition.tags.push(event);
    },
    updateTags: function(event) {
      this.selectedCompetition.tags = event;
    },
    selectCategory: function() {
      var catRef = firestore
        .collection("categories")
        .doc(this.selectedCompetition.parentCategory);
      var getSubCat = catRef
        .get()
        .then(doc => {
          if (!doc.exists) {
            console.log("No such document!");
          } else {
            this.subCategories = doc.data().subcategories;
          }
        })
        .catch(err => {
          console.log("Error getting document", err);
        });
      this.categoryChanged = false;
      Vue.nextTick(() => {
        this.categoryChanged = true;
      });
    },
    checkSlug: function() {
      if (this.debounceSlug) clearTimeout(this.debounceSlug);
      this.slugValid = "searching";
      this.debounceSlug = setTimeout(() => {
        let localCheckSlugRandom = Math.random();
        this.checkSlugRandom = localCheckSlugRandom;
        firestore
          .collection("posts")
          .where("slug", "==", this.selectedCompetition.slug)
          .get()
          .then(querySnapshot => {
            if (localCheckSlugRandom != this.checkSlugRandom) return;
            if (!querySnapshot.empty) {
              this.slugValid = "invalid";
            } else {
              this.slugValid = "valid";
            }
          });
      }, 500);
    },
    setupFroala: function(currentData) {
      setTimeout(() => {
        console.log(currentData);
        var fbEditor = document.getElementById("fb-editor");
        //Removing the existing formbuilder
        var testForm = $("#fb-editor").find(".form-builder");
        if (testForm.length !== 0) {
          $(testForm).remove();
        }
        //Create new formbuilder based on whether there is existing data or not.
        if (currentData.formData) {
          var options = {
            formData: currentData.formData,
            dataType: "json"
          };
          this.formBuilder = $(fbEditor).formBuilder(options);
        } else {
          var defaultData =
            '[    {      "type": "textarea",      "required": true,      "label": "Tell us in 25 words or less........",      "className": "form-control",      "name": "textarea-1549837574814",      "subtype": "textarea",      "rows": "4"    },    {      "type": "text",      "required": true,      "label": "First Name",      "className": "form-control",      "name": "text-1549837609949",      "subtype": "text"    },    {      "type": "text",      "label": "Last Name",      "className": "form-control",      "name": "text-1549837627270",      "subtype": "text"    },    {      "type": "number",      "required": true,      "label": "Contact Number",      "className": "form-control",      "name": "number-1549837647059"    },    {      "type": "text",      "required": true,      "label": "Email",      "className": "form-control",      "name": "text-1549837662055",      "subtype": "text"    },    {      "type": "text",      "label": "Postcode",      "className": "form-control",      "name": "text-1549837729241",      "subtype": "text"    },    {      "type": "checkbox-group",      "label": "Please tick to confirm",      "name": "checkbox-group-1549837744924",      "values": [        {          "label": "I have read and agree to the Terms and Conditions",          "value": "option-terms"        },        {          "label": "I am over the age of 18",          "value": "option-age"        }      ]    },    {      "type": "button",      "subtype": "submit",      "label": "SUBMIT",      "className": "btn-default btn",      "name": "button-1554096713544",      "style": "default"    }  ]';
          var options = {
            formData: defaultData,
            dataType: "json"
          };
          this.formBuilder = $(fbEditor).formBuilder(options);
        }
      }, 100);
    },
    activeClass: function(a, b) {
      if (a == b) return "active";
      return "";
    },
    createCompetition: function() {
      var errorMessage = "";
      if (!this.newCompetition.name) {
        errorMessage = "Missing Competition Name";
      }
      if (errorMessage) {
        alert(errorMessage);
        return;
      }
      this.newCompetition.status = "draft";
      this.$firestore.competitions
        // .doc(this.newCompetition.key)
        .add(this.newCompetition);
      alert("Competition created");
      this.newCompetition = {
        meta: {
          title: "",
          description: ""
        }
      };
    },
    saveCompData: function() {
      var errorMessage = "";
      if (!this.selectedCompetition["name"]) {
        errorMessage = "Missing Competition Name";
      }
      if (!this.selectedCompetition["slug"]) {
        errorMessage = "Missing Competition Slug";
      }
      if (!this.selectedCompetition.title) {
        errorMessage = "Post Title is missing";
      }
      if (errorMessage) {
        alert(errorMessage);
        return false;
      }
      var formData = this.formBuilder.actions.getData("json");
      var textEntered = this.selectedCompetition.writtenContent;

      // Grab markup and escape it
      const $markup = $("<div/>");
      $markup.formRender({ formData });

      var scripts = `
        var s = document.createElement("script");
        s.setAttribute("src", "https://code.jquery.com/jquery-3.4.1.min.js");
        s.setAttribute("async", true);

        s.onload = () => {
          $('.fb-button button').click(function(event) {
              $('#form-error').html("");
              var data = {};
          `;
      formData = JSON.parse(formData);
      formData.forEach(input => {
        switch (input.type) {
          case "text":
          case "number":
          case "select":
          case "textarea":
            scripts += `data['${$($.parseHTML(input.label)).text()}'] = $('#${$(
              $.parseHTML(input.name)
            ).text()}').val();`;
            if (input.required)
              scripts += `if(!data['${$(
                $.parseHTML(input.label)
              ).text()}']) { $('#form-error').html("<i>${$(
                $.parseHTML(input.label)
              ).text()}</i> is a required field."); return; }`;

            break;
          case "checkbox-group":
            scripts += `var stopLoop = false;`;
            input.values.forEach((checkbox, index) => {
              scripts += `var checkValue = $('#${$(
                $.parseHTML(checkbox.name)
              ).text()}-${index}').val();`;
              if (input.required)
                scripts += `if(!checkValue) { $('#form-error').html("<i>${$(
                  $.parseHTML(checkbox.label)
                ).text()}</i> is a required field."); stopLoop = true; }`;
              scripts += `data[checkValue] = true;`;
            });
            scripts += `if(stopLoop) return;`;
            break;
        }
      });
      scripts += `
      $('#submit-success').hide();
      $('#submit-processing').show();
      data.compId = '${this.selectedCompetition[".key"]}';
      $.ajax({
          method: 'POST',
          url: 'https://us-central1-${
            config.firebase.projectId
          }.cloudfunctions.net/submitCompetition',
          data: JSON.stringify(data),
          contentType: 'application/json',
          dataType: 'json',
          processData: false,
          success:function() {
              console.log('form success');
              $('.rendered-form').hide();
              $('#submit-processing').hide();
              $('#submit-success').show();
          },
      failure: function(err) {
              $('#submit-processing').hide();
              $('#form-error').html('There was an issue submitting the form. Please try again later.');
        console.log(err);
      }
        });
      });
      };
      document.getElementsByTagName("head")[0].appendChild(s);`;
      var formHtml = $markup.formRender("html");
      var contentHtml = textEntered + formHtml + 
        `<div id="form-error"></div>
        <div id="submit-processing" style="display:none;">Submitting...</div>
        <div id="submit-success" style="display:none;">Success! Your entry has been submitted.</div>`;

      var ampHtml =
        textEntered +
        ` <form method="post"
          action-xhr="https://us-central1-${
            config.firebase.projectId
          }.cloudfunctions.net/submitForm"
          target="_top">` +
        formHtml +
        `  <input type="hidden" id="compId" name="compId" value="${
          this.selectedCompetition[".key"]
        }">
        <div submit-success>
          <template type="amp-mustache">
            Submission successful!
          </template>
        </div>
        <div submitting>
          <template type="amp-mustache">
            Submitting...
          </template>
        </div>
        <div submit-error>
          <template type="amp-mustache">
            Submission failed, please try again later.
          </template>
        </div>
      </form>`;

      var tempObj = Object.assign({}, this.selectedCompetition);
      delete tempObj[".key"];
      tempObj.type = "competitions";
      tempObj.categories = [
        this.selectedCompetition.parentCategory,
        this.selectedCompetition.subCategory
      ];
      tempObj.scripts = scripts;
      tempObj.formData = formData;
      tempObj.content = contentHtml;
      tempObj.ampContent = ampHtml;
      tempObj.writtenContent = textEntered;
      console.log("this is submit comp");
      //console.log(submitcomp);
      this.$firestore.competitions
        .doc(this.selectedCompetition[".key"])
        .update(tempObj);
      $("ul.ic-fb_uploader-files > li").hide();
      return true;
    },
    getResults: function() {
      firestore
        .collection("competitions")
        .doc(this.selectedCompetition[".key"])
        .collection("results")
        .get()
        .then(snap => {
          this.results = snap.docs.map(doc => doc.data());
        });
    },
    onUploadedCompImage: function(e, attrib) {
      e.getDownloadURL().then(url => {
        this.selectedCompetition[attrib] = url;
      });
    },
    onUpload: function(e) {
      e.doUpload();
    },
    onDelete: function(e) {
      e.doDelete();
    },
    getFileName: function(file) {
      return file.name + Math.floor(Math.random() * 1000);
    },
    selected: function() {
      this.slugValid = "";
      this.$refs.competitionSelector.style.setProperty(
        "--inputColor",
        "aliceblue"
      );
      this.setupFroala(this.selectedCompetition);
      if (this.selectedCompetition.parentCategory) {
        this.selectCategory();
      }
      if (!this.selectedCompetition.meta)
        this.selectedCompetition.meta = { title: "", description: "" };
    },
    changeColor: function() {
      this.$refs.competitionSelector.style.setProperty("--inputColor", "black");
    },
    publishCompetition: function() {
      var result = this.saveCompData();
      if (!result) return;
      this.$firestore.competitions
        .doc(this.selectedCompetition[".key"])
        .update({
          status: "publish"
        });
      // set published true
    },
    previewCompetition: function() {
      var result = this.saveCompData();
      if (!result) return;
      this.$firestore.competitions
        .doc(this.selectedCompetition[".key"])
        .update({
          status: "preview"
        });
      // set published true
    },
    unpublishCompetition: function() {
      var confirm = window.confirm(
        "Are you sure you would like to UNPUBLISH this competition? The page URL will no longer function."
      );
      if (confirm) {
        this.$firestore.competitions
          .doc(this.selectedCompetition[".key"])
          .update({
            status: "draft"
          });
      }

      // set published false
    },
    exportCsv: function() {
      var items = this.results;
      const replacer = (key, value) => (value === null ? "" : value); // specify how you want to handle null values here
      const header = Object.keys(items[0]);
      let csv = items.map(row =>
        header
          .map(fieldName => JSON.stringify(row[fieldName], replacer))
          .join(",")
      );
      csv.unshift(header.join(","));
      csv = csv.join("\r\n");

      //Download the file as CSV
      var downloadLink = document.createElement("a");
      var blob = new Blob(["\ufeff", csv]);
      var url = URL.createObjectURL(blob);
      downloadLink.href = url;
      downloadLink.download = "DataDump.csv"; //Name the file here
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    },
    getSeletedTags: function(query) {
      if (query) {
        this.searchTags(query);
      }
    }
  }
};
</script>

<style>
.tab-container {
  display: flex;
}
button.tab:hover {
  font-weight:bold;
  border-bottom: #fff solid 4px;
}
button.tab {
  font-weight: normal;
  border-radius:0%;
  padding: 1em;
  color: rgba(255, 255, 255, 0.685);
  margin-right: 5px;
}
button.active-tab {
  background: rgba(255, 255, 255, 0.329);
  border-bottom: #fff solid 4px;
  box-sizing: border-box;
  color: #fff;
  font-weight:bold;
}

</style>
<style scoped>

h1 {
  margin-top: 0;
}

img {
  width: 100%;
}

#fb-editor {
  margin-top: 20px;
  color: black;
}

.section-title {
  margin-bottom: 1.5em;
}

.input-box {
  width: 100%;
}

.ic-fb_uploader {
  width: 100px;
  overflow: hidden;
  margin-top: 0;
}

.ic-fb_uploader ul li {
  display: none;
}
.slug-input.invalid {
  border: 1px solid red;
}
.slug-input.invalid span {
  color: red;
}
.slug-input.valid {
  border: 1px solid green;
}
.slug-input.valid span {
  color: green;
}
.slug-input.searching {
  border: 1px solid yellow;
}
.pub-buttons {
  margin: 20px 5px;
}
table {
  font-family: "Arial";
  margin: 25px auto;
  border-collapse: collapse;
  border: 1px solid #eee;
  border-bottom: 2px solid #00cccc;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1), 0px 10px 20px rgba(0, 0, 0, 0.05),
    0px 20px 20px rgba(0, 0, 0, 0.05), 0px 30px 20px rgba(0, 0, 0, 0.05);
}
table tr:hover {
  background: #f4f4f4;
}
table tr:hover td {
  color: #555;
}
table th,
table td {
  color: #fff;
  border: 1px solid #eee;
  padding: 12px 35px;
  border-collapse: collapse;
}
table th {
  background: #00cccc;
  color: #fff;
  text-transform: uppercase;
  font-size: 12px;
}
table th.last {
  border-right: none;
}
select option {
  color: black;
}

.images {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.tag-input-container {
  margin-bottom: 1em;
}
</style>


// WEBPACK FOOTER //
// competitions.vue?3e3b2c55